import { ApiFactory } from "@collapick/utils/dist/ApiFactory";
import { useUserContext } from "../apps/FormProcessApp/Context/UserContext";

const useApi = () => {
    const userContext = useUserContext();
    return ApiFactory(userContext.token, null, true, true)
};

export default useApi;